import DB from 'offline/db'
import F from 'offline/filter/constants'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/tags.php
export default {
	run: function(filter, data, config, global) {
		global.tags = { game: {}, item: {} }
		if (!global.gameIds || !global.gameIds.length || !global.userIndex || !global.userIndex.length) return

		var inUsers = Util.in(global.userIndex)
		var rows = DB.query('SELECT tag_id, game_id FROM tag_attach WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + inUsers + ')')
		for (var i = 0; i < rows.length; i++) {
			if (!global.tags.game[rows[i].game_id]) global.tags.game[rows[i].game_id] = []
			global.tags.game[rows[i].game_id].push(rows[i].tag_id)
		}

		if (!global.resultIndex || !global.resultIndex.length || config.resultType === F.RESULT_GAME) return

		var field = false
		if (config.resultType === F.RESULT_COLLECTION) field = 'collection_id'
		if (config.resultType === F.RESULT_RATING) field = 'rating_id'
		if (config.resultType === F.RESULT_PLAY) field = 'play_id'
		if (!field) return

		var itemRows = DB.query(
			'SELECT tag_id, ' + field + ' AS item_id FROM tag_attach WHERE ' + field + ' IN(' + Util.in(global.resultIndex) + ') AND user_id IN(' + inUsers + ')'
		)

		for (var j = 0; j < itemRows.length; j++) {
			if (!global.tags.item[itemRows[j].item_id]) global.tags.item[itemRows[j].item_id] = []
			global.tags.item[itemRows[j].item_id].push(itemRows[j].tag_id)
		}
	}
}
